import { useContext } from 'react';
import { UPDATE_CONTEXT_PROPERTY } from './createProvider';
export var createUseUpdate = function createUseUpdate(context) {
  var useUpdate = function useUpdate() {
    var _useContext = useContext(context),
        update = _useContext[UPDATE_CONTEXT_PROPERTY];

    return update;
  };

  return useUpdate;
};